import fetch from '../utilities/fetchAxios'

export const getAddress = async () => {
  const method = 'GET'
  const path = '/location/v1/addresses'
  return fetch(method, path, {})
}
